import { Action } from 'redux';
import {
    KpiSummary,
    SalesAttribution,
    TopItems,
    Adjustments,
    Leaderboard,
    SalesDashboardFilters
} from 'model/salesDashboard';

// Error actions
export const SALES_DASHBOARD_ERROR = 'salesDashboard/error';
export interface SalesDashboardErrorAction extends Action<typeof SALES_DASHBOARD_ERROR> {
    payload: { error: string };
}

export const SALES_DASHBOARD_CLEAR_ERROR = 'salesDashboard/clear_error';
export type SalesDashboardClearErrorAction = Action<typeof SALES_DASHBOARD_CLEAR_ERROR>;

// KPI Summary actions
export const SALES_DASHBOARD_KPI_SUMMARY_FETCH_START = 'salesDashboard/kpiSummary/fetch_start';
export type SalesDashboardKpiSummaryFetchStartAction = Action<typeof SALES_DASHBOARD_KPI_SUMMARY_FETCH_START>;

export const SALES_DASHBOARD_KPI_SUMMARY_FETCH_SUCCESS = 'salesDashboard/kpiSummary/fetch_success';
export interface SalesDashboardKpiSummaryFetchSuccessAction
    extends Action<typeof SALES_DASHBOARD_KPI_SUMMARY_FETCH_SUCCESS> {
    payload: { kpiSummary: KpiSummary };
}

// Sales Attribution actions
export const SALES_DASHBOARD_SALES_ATTRIBUTION_FETCH_START = 'salesDashboard/salesAttribution/fetch_start';
export type SalesDashboardSalesAttributionFetchStartAction = Action<
    typeof SALES_DASHBOARD_SALES_ATTRIBUTION_FETCH_START
>;

export const SALES_DASHBOARD_SALES_ATTRIBUTION_FETCH_SUCCESS = 'salesDashboard/salesAttribution/fetch_success';
export interface SalesDashboardSalesAttributionFetchSuccessAction
    extends Action<typeof SALES_DASHBOARD_SALES_ATTRIBUTION_FETCH_SUCCESS> {
    payload: { salesAttribution: SalesAttribution };
}

// Top Items actions
export const SALES_DASHBOARD_TOP_ITEMS_FETCH_START = 'salesDashboard/topItems/fetch_start';
export type SalesDashboardTopItemsFetchStartAction = Action<typeof SALES_DASHBOARD_TOP_ITEMS_FETCH_START>;

export const SALES_DASHBOARD_TOP_ITEMS_FETCH_SUCCESS = 'salesDashboard/topItems/fetch_success';
export interface SalesDashboardTopItemsFetchSuccessAction
    extends Action<typeof SALES_DASHBOARD_TOP_ITEMS_FETCH_SUCCESS> {
    payload: { topItems: TopItems };
}

// Adjustments actions
export const SALES_DASHBOARD_ADJUSTMENTS_FETCH_START = 'salesDashboard/adjustments/fetch_start';
export type SalesDashboardAdjustmentsFetchStartAction = Action<typeof SALES_DASHBOARD_ADJUSTMENTS_FETCH_START>;

export const SALES_DASHBOARD_ADJUSTMENTS_FETCH_SUCCESS = 'salesDashboard/adjustments/fetch_success';
export interface SalesDashboardAdjustmentsFetchSuccessAction
    extends Action<typeof SALES_DASHBOARD_ADJUSTMENTS_FETCH_SUCCESS> {
    payload: { adjustments: Adjustments };
}

// Leaderboard actions
export const SALES_DASHBOARD_LEADERBOARD_FETCH_START = 'salesDashboard/leaderboard/fetch_start';
export type SalesDashboardLeaderboardFetchStartAction = Action<typeof SALES_DASHBOARD_LEADERBOARD_FETCH_START>;

export const SALES_DASHBOARD_LEADERBOARD_FETCH_SUCCESS = 'salesDashboard/leaderboard/fetch_success';
export interface SalesDashboardLeaderboardFetchSuccessAction
    extends Action<typeof SALES_DASHBOARD_LEADERBOARD_FETCH_SUCCESS> {
    payload: { leaderboard: Leaderboard };
}

// Filters action
export const SALES_DASHBOARD_UPDATE_FILTERS = 'salesDashboard/update_filters';
export interface SalesDashboardUpdateFiltersAction extends Action<typeof SALES_DASHBOARD_UPDATE_FILTERS> {
    payload: { filters: Partial<SalesDashboardFilters> };
}

// Union type of all sales dashboard actions
export type SalesDashboardAction =
    | SalesDashboardErrorAction
    | SalesDashboardClearErrorAction
    | SalesDashboardKpiSummaryFetchStartAction
    | SalesDashboardKpiSummaryFetchSuccessAction
    | SalesDashboardSalesAttributionFetchStartAction
    | SalesDashboardSalesAttributionFetchSuccessAction
    | SalesDashboardTopItemsFetchStartAction
    | SalesDashboardTopItemsFetchSuccessAction
    | SalesDashboardAdjustmentsFetchStartAction
    | SalesDashboardAdjustmentsFetchSuccessAction
    | SalesDashboardLeaderboardFetchStartAction
    | SalesDashboardLeaderboardFetchSuccessAction
    | SalesDashboardUpdateFiltersAction;
